import React from 'react';
import { getDiaryMode, getPeriodName } from './string-format-helper';
import SubmitButton from '../components/submit-button/submit-button';

export const getDefaultCreateClassroomData = (
  classroom?: ClassroomStudents
) => {
  const defaultData: CreateClassroomFormData = {
    id: classroom ? classroom.id : null,
    name: classroom ? classroom.name : null,
    period: classroom ? classroom.period : null,
    diaryMode: classroom ? classroom.diaryMode : null,
  };

  return defaultData;
};

export const openCreateClassroomModal = (
  data: CreateClassroomFormData,
  defaultCreateClassroomData: CreateClassroomFormData,
  setCreateClassroomData: React.Dispatch<
    React.SetStateAction<CreateClassroomFormData>
  >,
  setModalContent: (content: ModalContent) => void,
  createClassroomPromise: (data: CreateClassroomFormData) => Promise<void>,
  onDeleteClassroom?: () => void
) => {
  const resetFormData = () => {
    return new Promise<void>((resolve) => {
      setCreateClassroomData(defaultCreateClassroomData);

      resolve();
    });
  };

  const isEditing = typeof data.id === 'number';
  const title = isEditing ? 'Editar turma' : 'Criar turma';
  const submitButtonTitle = isEditing ? 'salvar turma' : 'criar turma';

  setModalContent({
    title,
    modalContent: renderCreateClassroom(
      data,
      defaultCreateClassroomData,
      setCreateClassroomData,
      setModalContent,
      createClassroomPromise,
      onDeleteClassroom
    ),
    submitButtonTitle,
    submitButtonType: 'primary',
    submitData: data,
    onSubmitButtonClick: createClassroomPromise,
    onCloseModal: resetFormData,
    isOpen: true,
  });
};

const handleCreateClassroomInputChange = (
  evt:
    | React.ChangeEvent<HTMLInputElement>
    | React.ChangeEvent<HTMLSelectElement>,
  data: CreateClassroomFormData,
  defaultCreateClassroomData: CreateClassroomFormData,
  setCreateClassroomData: React.Dispatch<
    React.SetStateAction<CreateClassroomFormData>
  >,
  setModalContent: (content: ModalContent) => void,
  createClassroomPromise: (data: CreateClassroomFormData) => Promise<void>,
  onDeleteClassroom?: () => void
) => {
  const newData = {
    ...data,
    [evt.target.id]: evt.target.value,
  };

  setCreateClassroomData(newData);
  openCreateClassroomModal(
    newData,
    defaultCreateClassroomData,
    setCreateClassroomData,
    setModalContent,
    createClassroomPromise,
    onDeleteClassroom
  );
};

const renderCreateClassroom = (
  data: CreateClassroomFormData,
  defaultCreateClassroomData: CreateClassroomFormData,
  setCreateClassroomData: React.Dispatch<
    React.SetStateAction<CreateClassroomFormData>
  >,
  setModalContent: (content: ModalContent) => void,
  createClassroomPromise: (data: CreateClassroomFormData) => Promise<void>,
  onDeleteClassroom?: () => void
) => {
  return (
    <div>
      <label htmlFor='name'>Nome</label>
      <input
        id='name'
        name='name'
        placeholder='Nome'
        type='text'
        onChange={(evt) =>
          handleCreateClassroomInputChange(
            evt,
            data,
            defaultCreateClassroomData,
            setCreateClassroomData,
            setModalContent,
            createClassroomPromise,
            onDeleteClassroom
          )
        }
        defaultValue={data.name ? data.name : null}
      />

      <label htmlFor='period'>Período</label>
      <select
        name='period'
        id='period'
        defaultValue={data.period ? data.period : 'default'}
        onChange={(evt) =>
          handleCreateClassroomInputChange(
            evt,
            data,
            defaultCreateClassroomData,
            setCreateClassroomData,
            setModalContent,
            createClassroomPromise,
            onDeleteClassroom
          )
        }
      >
        <option value='default' disabled hidden>
          Selecionar
        </option>
        <option value='Morning'>{getPeriodName('Morning')}</option>
        <option value='Afternoon'>{getPeriodName('Afternoon')}</option>
        <option value='Night'>{getPeriodName('Night')}</option>
        <option value='WholeDay'>{getPeriodName('WholeDay')}</option>
      </select>

      <label htmlFor='diaryMode'>Módulo</label>
      <select
        name='diaryMode'
        id='diaryMode'
        defaultValue={data.diaryMode ? data.diaryMode : 'default'}
        onChange={(evt) =>
          handleCreateClassroomInputChange(
            evt,
            data,
            defaultCreateClassroomData,
            setCreateClassroomData,
            setModalContent,
            createClassroomPromise,
            onDeleteClassroom
          )
        }
      >
        <option value='default' disabled hidden>
          Selecionar
        </option>
        <option value='Preschool'>{getDiaryMode('Preschool')}</option>
        <option value='Simple'>{getDiaryMode('Simple')}</option>
      </select>

      {onDeleteClassroom && (
        <div style={{ marginTop: '24px', borderTop: '1px solid #e0e0e0', paddingTop: '16px' }}>
          <SubmitButton
            buttonStyle={{width: '100%', marginLeft: '0'}}
            value='deletar turma'
            variant='secondary'
            onClick={onDeleteClassroom}
          />
        </div>
      )}
    </div>
  );
};
